<template>
	<div class="tab-body">
		<div class="search">
			<el-form ref="form" :model="searchParams" label-width="80px">
				<el-row>
					<el-col :span="6">
						<el-form-item label="姓名">
							<el-input v-model="searchParams.name"></el-input>
						</el-form-item>
					</el-col>
					<el-collapse-transition>
						<div v-if="isShowMoreSearch">
							<!--隐藏区域-->
						</div>
					</el-collapse-transition>
					<div class="search-btn">
						<el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
						<el-button @click="clearSearchVal">清空</el-button>
					</div>
				</el-row>
			</el-form>
		</div>
		<div class="operator">
			<el-button type="primary" size="mini" icon="el-icon-plus" @click="toSave()"
				v-has-permission-code-and="'003000350005'">添加</el-button>
			<el-button type="danger" size="mini" icon="el-icon-delete" @click="batchRemove()">批量删除</el-button>
			<el-button type="primary" size="mini" v-has-permission-code-and="'003000100025'"
				@click="batchPush()">批量推送</el-button>
		</div>
		<div class="dataTable autoFlex" v-if="listData">
			<el-table class="table" :data="listData.records" stripe border height="auto" ref="multipleTable"
				@selection-change="selectionChange" v-loading="listLoading">
				<el-table-column type="selection" width="55" fixed="left"></el-table-column>

				<el-table-column prop="name" width="110" label="姓名"></el-table-column>
				<el-table-column prop="sex" width="55" label="性别">
					<template slot-scope="props">
						{{ props.row.sex == 1 ? '男' : '女' }}
					</template>
				</el-table-column>
				<el-table-column prop="mz" width="90" label="民族"></el-table-column>
				<el-table-column prop="moblie" width="150" label="手机"></el-table-column>
				<el-table-column prop="tjr" width="210" label="推荐人">
					<template slot-scope="scope">
						<el-tag v-if="scope.row.tjr" type="warning" size="mini">{{ scope.row.tjr }}</el-tag>
						<el-tag v-if="scope.row.tjrmbl" size="mini">{{ scope.row.tjrmbl }}</el-tag>
					</template>
				</el-table-column>
				<el-table-column prop="cnt2" label="2级分销"></el-table-column>
				<el-table-column prop="cnt3" label="3级分销"></el-table-column>
				<el-table-column label="操作" fixed="right" width="255px">
					<template slot-scope="scope">
						<div class="dataTable-operator">
							<el-button size="mini" @click="toDetail(scope.$index, scope.row)">详情</el-button>
							<el-button size="mini" @click="toUpdate(scope.$index, scope.row)"
								v-has-permission-code-and="'003000350010'">编辑</el-button>
							<el-button size="mini" type="danger" @click="remove(scope.$index, scope.row)"
								v-has-permission-code-and="'003000350020'">删除</el-button>
						</div>
					</template>
				</el-table-column>
			</el-table>
			<div class="pageBar">
				<el-pagination @size-change="sizeChange" @current-change="currentChange" :total="listData.total"
					:page-size="page.size" :current-page="page.current" :layout="this.$constant.page.layout"
					:page-sizes="this.$constant.page.pageSizes"></el-pagination>
			</div>
		</div>
		<edit ref="edit"></edit>
		<pushadd ref="pushadd"></pushadd>
	</div>
</template>
<script>
import edit from './edit.vue';
import api from '@/api/xueli/xlstudent.js';
import pushadd from './pushadd.vue';
import { log } from 'console';
export default {
	name: 'xlstudent',
	components: {
		edit,
		pushadd
	},
	data() {
		return {
			searchParams: {},
			isShowMoreSearch: false,
			listLoading: false,
			listData: [],
			multipleSelection: [],
			selected: [],
			page: new this.$constant.pageObj(),
		};
	},
	methods: {
		//获取数据
		list() {
			this.listLoading = true;
			let params = this.$utils.merger(this.searchParams, this.page);
			api.list(params, response => {
				this.listData = response.data;
				this.listLoading = false;
			})
		},
		//去添加
		toSave() {
			this.$refs.edit.open({}, '添加', false);
		},
		//去编辑
		toUpdate(index, row) {
			let editParameter = {
				id: row.id
			};
			this.$refs.edit.open(editParameter, '编辑');
		},
		//去详情
		toDetail(index, row) {

			let detailParameter = {
				id: row.id
			};
			this.$refs.edit.open(detailParameter, '详情', true);
		},
		//删除
		remove(index, row) {

			let parameter = {
				ids: row.id
			}
			this.$utils.confirm.warning('提示', '确定删除吗？', () => {
				api.remove(
					parameter,
					response => {
						this.$utils.msg.success(response.msg);
						this.list();
					},
					response => {
						this.$utils.msg.warning(response.msg);
					}
				);
			});
		},
		//批量删除
		batchRemove() {
			if (!this.selected || this.selected.length == 0) {
				this.$utils.msg.info('请选择至少一行');
				return;
			}
			let parameter = {
				ids: this.selected
			};
			this.$utils.confirm.warning('提示', '确定删除吗？', () => {
				api.remove({
					ids: this.selected
				},
					response => {
						this.$utils.msg.success(response.msg);
						this.list();
					},
					response => {
						this.$utils.msg.warning(response.msg);
					}
				);
			});
		},
		//批量推送
		batchPush() {
			if (!this.selected || this.selected.length == 0) {
				this.$utils.msg.info('请选择至少一行');
				return;
			}
			this.$refs.pushadd.open(this.selected, "批量推送");
			this.selected = []
			// 情况选择
			this.$refs.multipleTable.clearSelection();
		},
		//改变选择项
		selectionChange(val) {
			//清空
			this.selected = [];
			for (let item of val) {
				this.selected.push({
						sid: item.id,
						studentName: item.name
					});
			}
		},
		//改变每页显示数量
		sizeChange(val) {
			this.page.size = val;
			this.list();
		},
		//改变现在的页码
		currentChange(val) {
			this.page.current = val;
			this.list();
		},

		//搜索
		search() {
			this.list();
		},
		//清空搜索框
		clearSearchVal() {
			this.searchParams = {};
		}
	},
	mounted() {
		this.list();
	}
};
</script>

<style lang="scss" scoped="scoped">
@import '~common/custom/css/common.scss';
</style>
